<template>
  <div class="flex">
    <div class="flex-1">
      <JGItemCell :value="certificate" class="mt-2" name="신청증명서" />
      <JGItemCell :value="name" class="mt-2" name="신청인" />
      <JGItemCell class="mt-2" name="증명분류" value="일반증명서" />
      <JGItemCell :vertical="true" class="mt-2" name="주민등록번호 공개 여부" value="미포함 (뒷자리 '*'로 비공개)" />
    </div>
    <div class="flex-1">
      <JGItemCell :value="pagePrice" class="mt-2" extra="원" name="한부당 수수료" />
      <JGItemCell :value="printPage" class="mt-2" extra="원" name="출력 부수" />
      <JGItemCell :value="totalPrice" class="mt-2" extra="원" name="총 금액" />
      <JGItemCell :value="amount" :vertical="true" class="mt-2" name="투입 금액" />
    </div>
  </div>
</template>

<script>
import JGItemCell from '@src/games/jongrogu/components/jg-item-cell.vue'

export default {
  name: 'JGPaymentReady',
  components: { JGItemCell },
  props: {
    certificate: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    pagePrice: {
      type: Number,
      required: true,
    },
    printPage: {
      type: Number,
      required: true,
    },
    totalPrice: {
      type: Number,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
  },
}
</script>
